import { MAX_DATEV_CLIENT_NUMBER, MAX_DATEV_CONSULTANT_NUMBER, MIN_DATEV_CONSULTANT_NUMBER } from "@finway-group/shared/lib/consts"
import { type Rule } from "antd/lib/form"
import { i18n } from "~Shared/locales/i18n"

export const createDatevClientAndConsultantRules = () => ({
    clientNumber: [
        () => ({
            validator: (_rule, value: string) => {
                if (!value) {
                    return Promise.resolve()
                }
                if (Number(value) > MAX_DATEV_CLIENT_NUMBER) {
                    return Promise.reject(new Error(i18n.t("validation:max.number", { max: MAX_DATEV_CLIENT_NUMBER })))
                }

                return Promise.resolve()
            },
        }),
    ] as Array<Rule>,
    consultantNumber: [
        () => ({
            validator: (_rule, value: string) => {
                if (!value) {
                    return Promise.resolve()
                }
                if (Number(value) > MAX_DATEV_CONSULTANT_NUMBER) {
                    return Promise.reject(new Error(i18n.t("validation:numeric_min_max", { min: MIN_DATEV_CONSULTANT_NUMBER, max: MAX_DATEV_CONSULTANT_NUMBER })))
                }
                if (Number(value) < MIN_DATEV_CONSULTANT_NUMBER) {
                    return Promise.reject(new Error(i18n.t("validation:numeric_min_max", { min: MIN_DATEV_CONSULTANT_NUMBER, max: MAX_DATEV_CONSULTANT_NUMBER })))
                }

                return Promise.resolve()
            },
        }),
    ] as Array<Rule>,
})
